export * from './mobile.constant';
